import { customerContractV2 } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    getCustomerContractV2List(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(customerContractV2.customerContractV2Base, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2SelectList(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2Base}select/`, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    addCustomerContractV2(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(customerContractV2.customerContractV2Base, data)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getJobTypes(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${customerContractV2.customerContractV2Base}job_types/`, data)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2Object(id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2Base}${id}/`)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    closeCustomerContractV2(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${customerContractV2.customerContractV2Base}${payload.id}/close_contract/`,
                    payload
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2Details(id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2Base}${id}/view/`)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    updateCustomerContractV2(payload) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${customerContractV2.customerContractV2Base}${payload.id}/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    partiallyUpdateCustomerContractV2(payload) {
        return new Promise((resolve, reject) => {
            axios
                .patch(
                    `${customerContractV2.customerContractV2Base}${payload.id}/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2Charges(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(customerContractV2.customerContractV2ChargeBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2ChargeSelect(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2ChargeBase}select/`, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2Options() {
        return new Promise((resolve, reject) => {
            axios
                .options(customerContractV2.customerContractV2Base)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getTariffStatistics(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2Base}tariff_statistics/`, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    addRatesToExistingContract(payload) {
        return new Promise((resolve, reject) => {
            axios
                .patch(
                    `${customerContractV2.customerContractV2Base}${payload.id}/add_container_type/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    renewContract(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${customerContractV2.customerContractV2Base}${payload.id}/renew_contract/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2ActivityLogs(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(customerContractV2.customerContractV2ActivityLogBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    getCustomerContractV2RateList(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(customerContractV2.customerContractV2RateBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    addCustomerContractV2Rate(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(customerContractV2.customerContractV2RateBase, data)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    updateCustomerContractV2Rate(payload) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${customerContractV2.customerContractV2RateBase}${payload.id}/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    deleteCustomerContractV2Rate(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${customerContractV2.customerContractV2RateBase}${id}/`)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    addCustomerContractV2Charge(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(customerContractV2.customerContractV2ChargeBase, data)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    updateCustomerContractV2Charge(payload) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${customerContractV2.customerContractV2ChargeBase}${payload.id}/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    deleteCustomerContractV2Charge(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${customerContractV2.customerContractV2ChargeBase}${id}/`)
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    exportCustomerContractV2Rates(id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${customerContractV2.customerContractV2Base}${id}/export_rates/`, {
                    responseType: "blob",
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
    bulkUploadCustomerContractV2Rates(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${customerContractV2.customerContractV2Base}${payload.id}/bulk_upload_rates/`,
                    payload.data
                )
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
});
